import styled from 'styled-components';

export default styled.div`
  height: 100%;
  > div {
    height: 100%;
  }

  .bar-style,
  .info-style {
    flex-grow: 1;
    padding: 12px 12px 0 12px;
    background-color: rgb(255, 255, 255);
    color: rgb(21, 101, 192);
    transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    border-radius: 4px;
    box-shadow: rgba(181, 181, 181, 0.26) 0px 0px 5px 0px;
  }
  .second_section {
    height: calc(100% - 255px - 24px);
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .sort-wrap {
    display: flex;
    justify-content: flex-end;
    gap: 18px;
    align-items: center;
  }
  .bottom-arrow {
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 6px solid rgb(21, 101, 192);
  }
`;
